import { AfterViewInit, Component, OnInit, HostListener } from '@angular/core';

import { Router } from '@angular/router';
import NavMenuService from '../nav-menu-service';

@Component({
	selector: 'app-nav-menu-mobile',
	templateUrl: './nav-menu-mobile.component.html',
	styleUrls: ['./nav-menu-mobile.component.scss']
})

export class NavMenuMobileComponent implements OnInit {

	expanded : boolean = false;

	constructor(private navMenuService : NavMenuService,
        private router: Router)
	{

	}

	ngOnInit(): void {		
		
	}	

	closeMobileMenu() 
	{
		this.expanded = false;
		this.navMenuService.setActivated(false);
	}
}
